import axios from 'axios';
import {BASE_URL} from './index';

const users = {
    register: (payload) => axios.post(`${BASE_URL}/doctor/register`, payload),
    login: (payload) => {
        return axios.post(`${BASE_URL}/users/login`, payload)
},
    update: (payload, salesPersonId, doctorId) => axios.post(`${BASE_URL}/${salesPersonId}/${doctorId}`, payload),
    uploadFile: (formData) => axios.post(`${BASE_URL}/upload`,formData)
}
  
export default users